import { render, staticRenderFns } from "./HorseChargeSupplier.vue?vue&type=template&id=6b548efc&"
import script from "./HorseChargeSupplier.vue?vue&type=script&lang=js&"
export * from "./HorseChargeSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports